<template>
<div class="transaction-record-container" :style="{'height': height + 'px'}">
  <Bubble :min="min" :max="max"></Bubble>
  <div class="header">
    <div class="title">
      <div>{{name}}</div>
      <div>总交易额</div>
    </div>
    <div class="price">
      <dv-digital-flop :config="{
          number: [showPrice], 
          toFixed: 2,
          textAlign: 'right',
          style: pirceStyle,
          animationFrame: 100
        }" 
        style="width: 150px; height: 45px;"/>
      万元
    </div>
  </div>
  <vue-seamless-scroll :style="{'height': seamlessHeight + 'px'}" class="seamless-warp" :data="listData" :class-option="config">
    <div v-for="(item, index) in listData" :key="name + index" class="list-item">
      <div>{{item.name}}</div>
      <div>{{item.price}}元</div>
    </div>
  </vue-seamless-scroll>
</div>
</template>

<script>
import Bubble from '../../common/Bubble.vue'
import vueSeamlessScroll from 'vue-seamless-scroll'
import defaultData from '../js/transactionRecordDefaultData'
export default {
  components: {
    Bubble,
    vueSeamlessScroll
  },

  props: {
    name: {
      type: String,
      default: '干线'
    },
    price: {
      type: Number,
      default: 99.99
    },
    listData: {
      type: Array,
      default () {
        return defaultData
      }
    },
    setp: {
      type: Number,
      default: 0.5
    },
    height: {
      type: Number,
      default: 291
    },
    seamlessHeight: {
      type: Number,
      default: 200
    },
    min: Number,
    max: Number
  },

  data () {
    return {
      pirceStyle: {
        fill: '#34DEE5',
        fontSize: 30,
        fontWeight: 'bold'
      },
      config: {
        step: this.setp
      },
      showPrice: 0
    }
  },

  created () {
    this.showPrice = this.price
  },

  watch: {
    price () {
      const flag = Math.floor(Math.random() * (6 - 1 + 1) + 1)
      if (flag == 1) {
        this.showPrice = 0
        setTimeout(() => {
          this.showPrice = this.price
        }, 100)
      } else {
        this.showPrice = this.price
      }
    }
  }
}
</script>

<style lang="less" scoped>
.transaction-record-container {
  position: relative;
  width: 315px;
  padding: 6px 7px;
  background: linear-gradient(-21deg, rgba(14, 49, 115, 0.5), rgba(7, 20, 73, 0.5));
  border: 1px solid #1C476D;
  color: #fff;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 12px;
    padding: 0 8px;
    margin-bottom: 10px;
    background: linear-gradient(0deg, #07205B 0%, #060D34 100%);
    .title {
      font-size: 21px;
    }
    .price {
      display: flex;
      align-items: center;
      font-size: 21px;
    }
  }
  .seamless-warp {
    overflow: hidden;
    font-family: 'SourceHanSansCN-Regular';
    .list-item {
      display: flex;
      margin-bottom: 15px;
      div:nth-child(1) {
        flex-grow: 1;
        white-space: nowrap;
        overflow: hidden;
      }
      div:nth-child(2) {
        width: 100px;
        text-align: right;
      }
    }
  }
}
/deep/ .bubble-box {
  position: absolute;
  top: -20px;
  right: 20px;
}
</style>